module.exports = __webpack_public_path__ + "static/media/img-varanda.fca23187.jpg";